module.exports = __webpack_public_path__ + "img/email.6ca80e2b.svg";